import { render, staticRenderFns } from "./cabinet-deals-secondary-item.vue?vue&type=template&id=3f36bea1&scoped=true&"
import script from "./cabinet-deals-secondary-item.vue?vue&type=script&lang=js&"
export * from "./cabinet-deals-secondary-item.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-deals-secondary-item.vue?vue&type=style&index=0&id=3f36bea1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f36bea1",
  null
  
)

export default component.exports